module.exports = __webpack_public_path__ + "images/interview-Walmart_Global_Tech-2.svg";